import { lazy } from "react";
import PermissionRoute from "./PermissionRoute";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const Pricing = lazy(() => import("../../_features/pricing/pages/PricingPage"));

export const pricingRoutes = [
    {
        path: "/pricing", element:
            <PermissionRoute permission={ROUTE_PERMISSIONS.pricing.view} moduleName="Pricing">
                <Pricing />
            </PermissionRoute>
    }
];
